import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedCategories from './components/FeaturedCategories';
import PopularWorks from './components/PopularWorks';
import ReaderReviews from './components/ReaderReviews';
import CTASection from './components/CTASection';
import Footer from '@/components/feature/Footer';
import { comics } from '@/mocks/comics';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '哈哈漫画网',
    url: 'http://heniukeji.com/',
    description: '韩国漫画免费在线观看平台，提供高清韩漫全集下拉式阅读和漫画大全',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://heniukeji.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '哈哈漫画网',
    url: 'http://heniukeji.com/',
    description: '韩国漫画免费在线观看平台',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'hello@heniukeji.com',
      contactType: 'customer service',
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '韩国漫画免费在线观看 - 高清韩漫全集下拉式阅读 - 哈哈漫画网',
    description: '哈哈漫画网提供韩国漫画免费在线观看，支持高清韩漫全集下拉式阅读和漫画大全，让您随时随地畅读各种作品，享受便捷的娱乐服务。',
    url: 'http://heniukeji.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '哈哈漫画网',
    },
    primaryImageOfPage: comics[0].coverImage,
  };

  return (
    <>
      <SEOHead
        title="韩国漫画免费在线观看 - 高清韩漫全集下拉式阅读 - 漫画大全 - 哈哈漫画网"
        description="哈哈漫画网提供韩国漫画免费在线观看，支持高清韩漫全集下拉式阅读和漫画大全，让您随时随地畅读各种作品，享受便捷的娱乐服务。海量韩漫资源，每日更新，免费阅读。"
        keywords="韩国漫画, 免费在线观看, 高清韩漫, 下拉式阅读, 漫画大全, 哈哈漫画网"
        canonicalUrl="http://heniukeji.com/"
        ogTitle="韩国漫画免费在线观看 - 高清韩漫全集下拉式阅读 - 哈哈漫画网"
        ogDescription="哈哈漫画网提供韩国漫画免费在线观看，支持高清韩漫全集下拉式阅读和漫画大全，让您随时随地畅读各种作品，享受便捷的娱乐服务。"
        ogImage={comics[0].coverImage}
        schemaJson={[websiteSchema, organizationSchema, webpageSchema]}
      />

      <main>
        <HeroSection />
        <FeaturedCategories />
        <PopularWorks />
        <ReaderReviews />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}